const EMPTY_DEBUG_FILTER_REFERENCES = {
  properties: {
    accepted: new Set(),
    rejected: new Set()
  },
  formIds: {
    accepted: new Set(),
    rejected: new Set()
  },
  listIds: {
    accepted: new Set(),
    rejected: new Set()
  }
};
const mergeFiltersAndOperators = (f1, f2) => {
  return {
    filterTypes: new Set([...f1.filterTypes, ...f2.filterTypes]),
    operators: new Set([...f1.operators, ...f2.operators])
  };
};
const mergeFilterReferences = (r1, r2) => {
  return {
    properties: new Set([...r1.properties, ...r2.properties]),
    formIds: new Set([...r1.formIds, ...r2.formIds]),
    listIds: new Set([...r1.listIds, ...r2.listIds])
  };
};
const mergeDebugFilterReferences = (r1, r2) => {
  return {
    properties: {
      accepted: new Set([...r1.properties.accepted, ...r2.properties.accepted]),
      rejected: new Set([...r1.properties.rejected, ...r2.properties.rejected])
    },
    formIds: {
      accepted: new Set([...r1.formIds.accepted, ...r2.formIds.accepted]),
      rejected: new Set([...r1.formIds.rejected, ...r2.formIds.rejected])
    },
    listIds: {
      accepted: new Set([...r1.listIds.accepted, ...r2.listIds.accepted]),
      rejected: new Set([...r1.listIds.rejected, ...r2.listIds.rejected])
    }
  };
};
export const getAllFilterTypesAndOperators = filterBranch => {
  const branchFilterTypes = new Set();
  const branchOperators = new Set();
  const nestedFiltersAndOperators = filterBranch.filterBranches.reduce((allFiltersAndOperators, branch) => {
    const currentFiltersAndOperators = getAllFilterTypesAndOperators(branch);
    return mergeFiltersAndOperators(allFiltersAndOperators, currentFiltersAndOperators);
  }, {
    filterTypes: new Set(),
    operators: new Set()
  });
  filterBranch.filters.forEach(filter => {
    branchFilterTypes.add(filter.filterType);
    if (filter.filterType === 'PROPERTY') {
      branchOperators.add(filter.operation.operator);
    }
  });
  return mergeFiltersAndOperators({
    filterTypes: branchFilterTypes,
    operators: branchOperators
  }, nestedFiltersAndOperators);
};
export const getAllFilterReferences = filterBranch => {
  const currentProperties = new Set();
  const currentFormIds = new Set();
  const currentListIds = new Set();
  const nestedFilterReferences = filterBranch.filterBranches.reduce((allFilterReferences, branch) => {
    const branchReferences = getAllFilterReferences(branch);
    return mergeFilterReferences(allFilterReferences, branchReferences);
  }, {
    properties: new Set(),
    formIds: new Set(),
    listIds: new Set()
  });
  filterBranch.filters.forEach(filter => {
    if (filter.filterType === 'PROPERTY') {
      currentProperties.add(filter.property);
    } else if (filter.filterType === 'FORM_SUBMISSION' || filter.filterType === 'FORM_SUBMISSION_ON_PAGE') {
      if (filter.formId) currentFormIds.add(filter.formId);
    } else if (filter.filterType === 'IN_LIST') {
      currentListIds.add(filter.listId);
    }
  });
  return mergeFilterReferences(nestedFilterReferences, nestedFilterReferences);
};
export const getAllDebugFilterReferences = debugBranch => {
  const currentProperties = {
    accepted: new Set(),
    rejected: new Set()
  };
  const currentFormIds = {
    accepted: new Set(),
    rejected: new Set()
  };
  const currentListIds = {
    accepted: new Set(),
    rejected: new Set()
  };
  if (debugBranch.type === 'DebugAssociationFilterBranchEvaluationResult') {
    return debugBranch.associationResults.reduce((allDebugFilterReferences, branch) => {
      const branchReferences = getAllDebugFilterReferences(branch);
      return mergeDebugFilterReferences(allDebugFilterReferences, branchReferences);
    }, EMPTY_DEBUG_FILTER_REFERENCES);
  } else {
    const nestedDebugReferences = debugBranch.filterBranches.reduce((allDebugFilterReferences, branch) => {
      const branchReferences = getAllDebugFilterReferences(branch);
      return mergeDebugFilterReferences(allDebugFilterReferences, branchReferences);
    }, EMPTY_DEBUG_FILTER_REFERENCES);
    debugBranch.filters.forEach(debugFilter => {
      if (debugFilter.filter.filterType === 'PROPERTY') {
        if (debugFilter.acceptedStatus === 'ACCEPTED') {
          currentProperties.accepted.add(debugFilter.filter.property);
        } else {
          currentProperties.rejected.add(debugFilter.filter.property);
        }
      } else if (debugFilter.filter.filterType === 'FORM_SUBMISSION' || debugFilter.filter.filterType === 'FORM_SUBMISSION_ON_PAGE') {
        if (debugFilter.filter.formId) {
          if (debugFilter.acceptedStatus === 'ACCEPTED') {
            currentFormIds.accepted.add(debugFilter.filter.formId);
          } else {
            currentFormIds.rejected.add(debugFilter.filter.formId);
          }
        }
      } else if (debugFilter.filter.filterType === 'IN_LIST') {
        if (debugFilter.acceptedStatus === 'ACCEPTED') {
          currentListIds.accepted.add(debugFilter.filter.listId);
        } else {
          currentListIds.accepted.add(debugFilter.filter.listId);
        }
      }
    });
    return mergeDebugFilterReferences(nestedDebugReferences, {
      properties: currentProperties,
      formIds: currentFormIds,
      listIds: currentListIds
    });
  }
};
const getAcceptancesForFilterBranch = debugFilterBranch => {
  if (debugFilterBranch.type === 'DebugAssociationFilterBranchEvaluationResult') {
    return debugFilterBranch.associationResults.reduce((total, branch) => {
      return total + getAcceptancesForFilterBranch(branch);
    }, 0);
  }
  return debugFilterBranch.filters.reduce((total, filter) => total + Number(filter.acceptedStatus === 'ACCEPTED'), 0);
};
export const getDebugFilterBranchWithMostAcceptances = debugFilterBranches => {
  let mostAcceptances = -Infinity;
  let branchWithMostAcceptances = debugFilterBranches[0];
  debugFilterBranches.forEach(branch => {
    const acceptances = getAcceptancesForFilterBranch(branch);
    if (acceptances > mostAcceptances) {
      mostAcceptances = acceptances;
      branchWithMostAcceptances = branch;
    }
  });
  return branchWithMostAcceptances;
};